import { SubmitErrorHandler, SubmitHandler } from "react-hook-form";
import adaptCreateBrand from "../../adapters/adaptCreateAppBrand";
import CreateAppBrandingForm from "../../containers/CreateAppBrandingForm/CreateAppBrandingForm";
import useCreateAppBrand from "../../hooks/useCreateAppBrand/useCreateAppBrand";

const CreateAppBranding = () => {
	const defaultValues: Partial<AppBrand> = {
		name: "",
		textColor: "#000000",
		brandColor: "#ffffff"
	};

	const { mutate: createAppBrand, isLoading: isCreatingAppBrand } =
		useCreateAppBrand();

	const handleValidSubmit: SubmitHandler<Partial<AppBrand>> = (data) => {
		console.log("FORM IS VALID, SUBMIT FORM", adaptCreateBrand(data));

		createAppBrand(adaptCreateBrand(data));
	};

	const handleInvalidSubmit: SubmitErrorHandler<AppBrand> = (error) => {
		console.log("FAILED TO SUBMIT FORM", error);
	};

	return (
		<CreateAppBrandingForm
			defaultValues={defaultValues}
			onValidSubmit={handleValidSubmit}
			onInvalidSubmit={handleInvalidSubmit}
			isSubmitting={isCreatingAppBrand}
		/>
	);
};

export default CreateAppBranding;
